module.exports = __webpack_public_path__ + "static/img/img_logo.825bcaf0.png";